(() => {
  customElements.define('izuro-card-add', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog'); this.select = this.querySelector('select'); this.quantity = this.querySelector('input[type=number]');
      this.addEventListener('click', event=>{
        if (event.target.closest('[data-card-open]')) { event.preventDefault(); this.dialog.showModal(); }
        if (event.target.closest('[data-card-close]')) this.dialog?.close();
        if (event.target === this.dialog) { const rect=this.dialog.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close(); }
        if (event.target.closest('[data-card-add]')) { event.preventDefault(); this.add(event.target.closest('button')); }
      });
      this.select?.addEventListener('change', ()=>{
        const option = this.select.selectedOptions[0]; this.querySelector('[data-card-price]').textContent = option.dataset.price;
        this.quantity.min = option.dataset.min || 1; this.quantity.step = option.dataset.step || 1; this.quantity.value = this.quantity.min;
        if (option.dataset.max) this.quantity.max = option.dataset.max; else this.quantity.removeAttribute('max');
      });
    }
    async add(button) {
      if (this.busy || (this.quantity && !this.quantity.reportValidity())) return;
      const api = window.IzuroCartActions; const status = this.querySelector(this.dialog?.open ? '[data-card-dialog-status]' : '[data-card-status]');
      const option = this.select?.selectedOptions[0]; if(option?.disabled) return;
      this.busy = true; button.disabled = true; status.textContent = 'Adding…';
      try { await api.run(async()=>{
        await api.request('cart/add.js', {items:[{id:Number(option?.value || this.dataset.variant), quantity:Number(this.quantity?.value || this.dataset.quantity || 1)}]});
        const cart = await api.request('cart.js'); this.dialog?.close(); await api.refresh(cart, this.querySelector('button'), true); status.textContent = '';
      }); } catch(error) { status.textContent = error.message; }
      finally { this.busy = false; button.disabled = false; }
    }
  });
})();
